import apiClient from '../api-client';

export const getSharedResource = (accessor) => apiClient.get('/shared-resource/' + accessor).then(res => res.data);
export const getResourceByPath = (path) => apiClient.get('/resource/' + path).then(res => res.data);

export const uploadFiles = (files) => {
    let formData = new FormData();
    for (let file of files) {
        formData.append(file.name, file);
    }
    return apiClient.put('/resource', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then(res =>  { return res.dat; });
}